import React from 'react';
import { useNotificationsComponent } from 'src/v2/features/signUp/pages/notificationsHook';
import { ProfilePage } from 'src/v2/features/profile';

export const Notifications: React.FC = () => {
  const [render] = useNotificationsComponent();
  return <ProfilePage>{render()}</ProfilePage>;
};
